module["exports"] = [
  "Dr.",
  "Prof.",
  "PhD."
];



//////////////////
// WEBPACK FOOTER
// ./~/faker/lib/locales/sv/name/prefix.js
// module id = 1377
// module chunks = 0